/**
 * University (ตาราง `uniday_universities`) — เมนู Customers > Universities
 * ดูเอกสาร docs/features/05-uniday-university.md
 */

export const UNIDAY_UNIVERSITY_STATUSES = Object.freeze({
	ACTIVE: 1,
	INACTIVE: 0,
});

export const UNIDAY_UNIVERSITY_STATUS_OPTIONS = Object.freeze([
	{ name: 'All statuses', value: null },
	{ name: 'Active', value: UNIDAY_UNIVERSITY_STATUSES.ACTIVE },
	{ name: 'Inactive', value: UNIDAY_UNIVERSITY_STATUSES.INACTIVE },
]);

// mapping title / color ของ status ใช้กับ CBadge
export const UNIDAY_UNIVERSITY_TITLE = Object.freeze({
	STATUS: {
		[UNIDAY_UNIVERSITY_STATUSES.ACTIVE]: 'Active',
		[UNIDAY_UNIVERSITY_STATUSES.INACTIVE]: 'Inactive',
	},
});

export const UNIDAY_UNIVERSITY_COLOR = Object.freeze({
	STATUS: {
		[UNIDAY_UNIVERSITY_STATUSES.ACTIVE]: 'success',
		[UNIDAY_UNIVERSITY_STATUSES.INACTIVE]: 'alto',
	},
});

export const UNIDAY_UNIVERSITY_TABLE_FIELDS = Object.freeze([
	{ key: 'customerId', label: 'Customer ID', class: 'col-customer-id th-mw-100' },
	{ key: 'companyEn', label: 'Company EN', class: 'col-company th-mw-250' },
	{ key: 'companyTh', label: 'Company TH', class: 'col-company th-mw-250' },
	{ key: 'city', label: 'City', class: 'col-city th-mw-120' },
	{ key: 'state', label: 'State', class: 'col-state th-mw-120' },
	{ key: 'organizeId', label: 'DEPID / Organize ID', class: 'col-organize-id th-mw-150' },
	{ key: 'status', label: 'Status', class: 'col-status th-mw-80' },
]);

// column ปุ่ม Edit — ต่อท้ายเฉพาะคนที่มีสิทธิ์ manage (ดู views/UnidayUniversities.vue)
export const UNIDAY_UNIVERSITY_ACTION_FIELD = Object.freeze({ key: 'editId', label: '', class: 'col-action th-mw-80 text-right' });

// BE รับ .xls / .xlsx
export const UNIDAY_UNIVERSITY_IMPORT_FILE_EXTENSIONS = Object.freeze(['xlsx', 'xls']);
export const UNIDAY_UNIVERSITY_IMPORT_ACCEPT = [
	'.xlsx',
	'.xls',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.ms-excel',
].join(',');

// ข้อจำกัดความยาวจาก BE (422 "may not be greater than 100 characters")
export const UNIDAY_UNIVERSITY_ORGANIZE_ID_MAX_LENGTH = 100;
